import { ruleMap } from '../../utils/useValidator';

export const rules = (option: string) => ({
  email: {
    required: true,
    rules: [option === 'email' ? ruleMap.isValidEmail : ruleMap.isValidPhoneNumber],
  },
  password: {
    required: true,
    rules: [],
  },
});

export const initialData = {
  email: '',
  password: '',
};
